import { HomePageMedia } from "@/types/homepage";
import Image from "next/image";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { urlFor } from "@/sanity/lib/image";

const AsFeatured = ({
  content,
  expertFromHandler,
}: {
  content: HomePageMedia[] | undefined;
  expertFromHandler: () => void;
}) => {
  return (
    <div className="py-[48px] sm:py-[72px] md:py-[80px] lg:py-[100px] xl:py-[120px] px-4 xxs:px-6 sm:px-[40px]">
      <div className="mb-10 sm:mb-16 md:mb-20 xl:mb-[80px]">
        {content && content.length > 0 && (
          <Swiper
            slidesPerView={1.2}
            spaceBetween={0}
            loop={true}
            speed={3000}
            autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: true }}
            breakpoints={{
              480: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
            modules={[Autoplay]}
            className="w-full marquee-swiper"
          >
            {content.map((item, idx) => {
              const logoPath = item.image
                ? urlFor(item.image).width(260).height(96).format("webp").url()
                : "";
              const isLast = idx === content.length - 1;
              return (
                <SwiperSlide key={idx} className="h-auto">
                  <div className={`flex flex-col justify-between items-center text-center px-6 py-4 border-l ${isLast && content.length > 4 ? "" : "border-r"} border-[#E8E8E8] -ml-[1px] h-full min-h-[220px]`}>
                    <div className="h-[48px] flex items-center justify-center mb-4 w-full">
                      {logoPath ? (
                        <Image
                          src={logoPath}
                          alt={item.name}
                          width={130}
                          height={48}
                          className="max-h-full max-w-[130px] object-contain h-auto"
                        />
                      ) : (
                        <span className="font-bold text-base text-gray-700 ff_poppins">{item.name}</span>
                      )}
                    </div>
                    <p className="text-xs sm:text-sm font-medium text-[#4B5563] ff_poppins line-clamp-3 mb-6 leading-relaxed max-w-[240px]">
                      {item.title}
                    </p>
                    <Link
                      href={item.Hyperlink || "#"}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Read more about ${item.name}`}
                      className="text-xs sm:text-sm font-semibold text-[#1776F0] ff_poppins inline-flex items-center gap-1.5 hover:underline mt-auto min-h-[36px] py-1"
                    >
                      Read More
                      <span className="text-[14px] font-normal">→</span>
                    </Link>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      <div className="bg-[linear-gradient(135deg,_#021A38_0%,_#1776F0_60%,_#8F3EBC_100%)] rounded-[24px] p-[26px] flex md:items-center justify-between relative flex-col md:flex-row">
        <span className="size-[120px] bg-[#FFFFFF0D] rounded-full absolute top-[-30%] left-[70%] md:left-[20%]"></span>
        <div className="flex md:items-center flex-col md:flex-row gap-6">
          <Image
            className="max-w-[114px] md:max-w-[150px] xl:max-w-[196px] w-full h-auto"
            width={196}
            height={64}
            src="/assets/images/png/homepage/users.png"
            alt="users"
          />
          <p className="font-medium ff_poppins text-white text-sm xxs:text-base xs:text-lg sm:text-xl md:text-2xl">
            Still Confused? Talk to a Mentor directly.
          </p>
        </div>
        <button
          onClick={expertFromHandler}
          className="mt-5 md:mt-0 bg-white rounded-3xl py-3 px-6 sm:py-4 sm:px-8 text-[#0B57D0] font-semibold text-sm sm:text-base lg:text-xl ff_poppins cursor-pointer shadow-md hover:bg-gray-50"
        >
          Book a 1:1 Call
        </button>
      </div>
    </div>
  );
};

export default AsFeatured;
